import { type MoneyAmount } from 'types'

import { type MarketplacePriceCadence } from '../shared/types'
import { calculateDiscountDisplay, getDiscountTextSuffix } from '../shared/utils'

export const DiscountedPrice = ({ basePrice, discountedPrice, cadence, productSlug }: { basePrice: MoneyAmount, discountedPrice: MoneyAmount, cadence: MarketplacePriceCadence, productSlug: string }) => {
  let discountText = calculateDiscountDisplay(parseFloat(basePrice.value) * 100, parseFloat(discountedPrice.value) * 100, productSlug)
  discountText = `${discountText} ${getDiscountTextSuffix(cadence)}`

  return <p className='font-semi-bold text-violet-500'>{discountText}</p>
}
